import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Legend,
  Title,
  Tooltip,
} from "chart.js";
import { LineBarChartData } from "./interface";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Legend,
  Title,
  Tooltip
);

export default function Linegraph({
  lineGraphProps,
}: {
  lineGraphProps: any;
}) {
  let datasets: {
    label: string;
    data: number[];
    borderWidth: number;
    backgroundColor?: string;
  }[] = [];

  Object.keys(lineGraphProps).map((key) => {
    if (key === "y_axis") {
      if (
        typeof lineGraphProps[key][0] === "object" &&
        lineGraphProps[key][0] !== null &&
        !Array.isArray(lineGraphProps[key][0])
      ) {
        Object.keys(lineGraphProps[key][0]).map((key_of_y_axis) => {
          datasets.push({
            label: key_of_y_axis,
            data: lineGraphProps[key][0][key_of_y_axis],
            borderWidth: 1,
          });
        });
      } else if (Array.isArray(lineGraphProps[key])) {
        datasets.push({
          label: key,
          data: lineGraphProps[key],
          borderWidth: 1,
          // backgroundColor: "#7f26d3",
        });
      }
    }
    
  });

  const options = {
    // responsive:true,
    // plugins:{
    //   legend:{
    //     display:false
    //   }
    // }
    plugins: {
      colors: {
        forceOverride: true,
      },
      legend: {
        display: false,
      },
    },
  };
  const lineChartData = {
    labels: lineGraphProps.x_axis,
    // datasets: [
    //   {
    //     label: "",
    //     data: lineGraphProps.y_axis,
    //     borderWidth: 1,
    //     backgroundColor: "#7f26d3",
    //   },
    //   {
    // ],
    datasets: datasets,
    hoverOffset: 4,
  };
  // console.log("The X-Axis data is ", lineGraphProps.x_axis);
  return <Line options={options} data={lineChartData} />;
}
